<template>
  <div id="home">
    <div id="illustration-container">
      <img
        src="https://firebasestorage.googleapis.com/v0/b/exceptionjr-site.appspot.com/o/home-office.svg?alt=media&token=390311b6-e1ec-4693-a351-e9f404d9521a"
        alt
      />
    </div>
    <div id="presentation-container">
      <p id="presentation-text">
        Olá, nós somos a
        <br />
        <span>exception jr</span>
        empresa júnior do curso de
        <br />Sistemas de Informação
      </p>
      <p id="description-text">
        Estamos sempre prontos para fazer
        <br />do seu negócio,
        <span>uma exceção</span>
      </p>
      <router-link id="btn-to-services" to="/services">
        <font-awesome-icon :icon="['fas', 'chevron-right']"></font-awesome-icon>
        <p>Conheça nossos serviços</p>
      </router-link>
    </div>
  </div>
</template>

<script>
import ExceptionLogo from "@/components/ExceptionLogo";

export default {
  components: {
    ExceptionLogo
  }
};
</script>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css?family=Kalam:300,400,700&display=swap");

#home {
  @include reset-css;
  width: 100%;

  @include for-phone-only() {
    @include flexbox(column, center, center);
  }
  @include for-tablet-portraid-up() {
    // @include flexbox(column, flex-start, center);
    @include flexbox(row-reverse, space-between)
      // @include flexbox(row-reverse, space-around, space-around);;;;;;;;;;;;;;;;
  }
  @include for-tablet-landscape-up() {
  }
}

#illustration-container {
  width: 100%;
  @include for-tablet-portraid-up {
    width: 50%;
  }

  img {
    width: 100%;
  }
}

#presentation-container {
  @include flexbox(column, flex-start, center);

  #presentation-text {
    font-family: $fonte-secundaria;
    font-weight: 500;
    transition: font-size 0.5s;

    font-size: 5vw;
    line-height: 7.5vw;

    @include for-phone-only {
    }

    @include for-tablet-portraid-up {
      font-size: 2vw;
      line-height: 3vw;
      // font-size: 2.5vw;
      // line-height: 3.75vw;
    }

    @include for-tablet-landscape-up {
    }

    @include for-desktop-up {
    }

    span {
      display: block;
      font-family: $fonte-primaria;
      font-weight: 600;
      transition: font-size 0.5s;

      @include for-phone-only {
        font-size: 10vw;
        line-height: 12vw;
      }

      @include for-tablet-portraid-up {
        // font-size: 10vw;
        font-size: 4.5vw;
        line-height: 6vw;
        // font-size: 5vw;
        // line-height: 6vw;
      }
      @include for-tablet-landscape-up {
      }
      @include for-desktop-up {
      }
    }
  }
  #description-text {
    transition: font-size 0.5s;
    font-weight: 500;
    margin: 0;

    font-size: 4vw;
    line-height: 6vw;

    @include for-phone-only {
    }

    @include for-tablet-portraid-up {
      font-size: 1.5vw;
      line-height: 2.25vw;
    }

    @include for-tablet-landscape-up {
    }

    span {
      font-weight: bold;
    }
  }
  a {
    @include reset-css;
    text-decoration: none;
    @include flexbox(row, center, center);
    background: $verde-exception;
    border-radius: 10px;

    // margin: 30px 30px;
    margin: 30px 0;
    transition: all 0.2s;
    padding: 10px 20px;

    &:hover {
      transform: scale(1.05);
    }

    p {
      @include reset-css;
      color: #fff;
      font-family: $fonte-primaria;
      font-weight: 600;
      padding-left: 10px;

      @include for-phone-only {
        font-size: 4vw;
        line-height: 6vw;
      }

      @include for-tablet-portraid-up {
        font-size: 1.5vw;
        line-height: 2.25vw;
      }
      @include for-tablet-landscape-up {
        // font-size: 18px;
      }
      @include for-desktop-up {
        // font-size: 16px;
      }
    }
    svg {
      color: #fff;
      @include for-phone-only {
        width: 25px;
        height: 25px;
      }
      @include for-tablet-portraid-up {
        width: 30px;
        height: 30px;
      }
    }
  }
}
</style>
